module.exports = __webpack_public_path__ + "img/o_9.cfc5518e.png";